import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Image,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  Offcanvas,
  Accordion,
} from "react-bootstrap";
import "../styles/navbar.scss";
import ProfileBadge from "./CustomComponents/ProfileBadge/ProfileBadge";
import NotificationDropdown from "./CustomComponents/NotificationBell/NotificationDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../app/hooks";
import {
  setDate,
  setDeviceID,
  setFilterChosen,
  setFilterType,
  setDepartment,
  setOrganization,
  setEmployeeIds,
} from "../features/date/dashboardSlice";
import {
  setModalShow,
  setEmployeeDropShow,
  setManagerDropShow,
  setMoreDropShow,
} from "../features/addManager/addManagerSlice";
import { commonGetService } from "../utils/properties";
import { AccessInfo, AccessDetails } from "../pages/Dashboard";
import { setAllusers, setReportTypes } from "../features/reports/reportslice";
import { setDepartmentLists, setDesignationLists, setEmployeeSearch, setEmployeeStatusLists, setSystemStatusLists } from "../features/employee/employeeListSlice";
import { setDepartmentListsPerformance, setDesignationListsPerformance, setRangeValueLists1Performance, setRangeValueListsPerformance, setSearchPerformance } from "../features/employee/employeePerformanceSlice";
import { decryptPayload } from "../utils/auth";
import { setUserRole } from "../features/settingSlice/settingSlice";

interface layoutProps {
  children: React.ReactNode;
}
export interface userDetails {
  name: string;
  picture: string;
  employee_id: string;
  role: string;
}

interface tabHovered {
  dashboardHover: boolean;
  settingHover: boolean;
  projectHover: boolean;
  managerHover: boolean;
  addManagerHover: boolean;
  managerListHover: boolean;

  reportHover: boolean;
  screenshotHover: boolean;
  moreHover: boolean;
  roleHover: boolean;
  employeeHover: boolean;
}

interface FeatureDetails {
  features: AccessDetails[];
  status: boolean;
}

const NavbarLayout = (props: layoutProps) => {
  const Navigate = useNavigate();
  const location = useLocation();
  const addManager = useAppSelector((state) => state.addManager);
  const dispatch = useAppDispatch();

  const [navShow, setNavShow] = useState<boolean>(false);
  // const [projectHover, setProjectHover] = useState<boolean>(false);

  // const [mgrHover, setMgrHover] = useState<boolean>(false);
  // const [reportHover, setReportHover] = useState<boolean>(false);
  // const [screenshotHover, setScreenshotHover] = useState<boolean>(false);
  // const [moreHover, setMoreHover] = useState<boolean>(false);
  const [isManagerDropdown, setIsManagerDropdown] = useState<boolean>(false);

  const [isMoreClicked, setIsMoreClicked] = useState<boolean>(false);

  // const [settingHover, setSettingHover] = useState<boolean>(false);
  // const [dashboardHover, setDashboardHover] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [currentUserEmailId, setCurrentUserEmailId] = useState<string>("");
  const [activeKey, setActiveKey] = useState<any>("");
  const [accessInfo, setAccessInfo] = useState<AccessInfo>({});
  const [addManagerShow, setAddManagerShow] = useState<boolean>(false);
  const [accountDetailsShow, setAccountDetailsShow] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<boolean>(false);
  const [employeePerformance, setEmployeePerformance] = useState<boolean>(false);
  const [managerList, setManagerList] = useState<boolean>(false);



  // const [isManagerListHover, setIsManagerListHover] = useState<boolean>(false);
  // const [isAddManagerHover, setIsAddManagerHover] = useState<boolean>(false);
  // const [isRolesHover, setIsRolesHover] = useState<boolean>(false);

  const [hoveredState, setHoveredState] = useState<tabHovered>({
    dashboardHover: false,
    settingHover: false,
    projectHover: false,
    managerHover: false,
    addManagerHover: false,
    managerListHover: false,
    reportHover: false,
    screenshotHover: false,
    moreHover: false,
    roleHover: false,
    employeeHover: false,
  });

  const [currentProfileDetail, setCurrentProfileDetail] = useState<userDetails>(
    {
      name: "",
      picture: "",
      employee_id: "",
      role: "",
    }
  );

  // const [managerDropShow, setManagerDropShow] = useState<boolean>(false);
  const updateProfilePic = useAppSelector((state) => state.setting.isPicUpdate);

  const {
    dashboardHover,
    settingHover,
    projectHover,
    managerHover,
    addManagerHover,
    managerListHover,
    reportHover,
    screenshotHover,
    moreHover,
    roleHover,
    employeeHover,
  } = hoveredState;

  const roleDetails = () => {
    const roleDetailsString = localStorage.getItem("roleDetails");
    if (roleDetailsString) {
      return decryptPayload(roleDetailsString);
    } else {
      return null;
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (addManager?.employeeDropShow) {
        dispatch(setEmployeeDropShow(false));
      }
      if (addManager?.managerDropShow) {
        dispatch(setManagerDropShow(false));
      }
      if (addManager?.moreDropShow) {
        dispatch(setMoreDropShow(false));
      }
    };
    // Add scroll event listener
    window.addEventListener("wheel", handleScroll);
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("wheel", handleScroll);
      window.addEventListener("scroll", handleScroll);
    };
  }, [addManager?.managerDropShow, addManager?.moreDropShow, addManager?.employeeDropShow]);



  useEffect(() => {
    if (location.pathname.includes("managerList")) {
      setActiveKey("0"); // Keep the first accordion item open
    } else if (location.pathname.includes("roles")) {
      setActiveKey("1");
    } else if (location.pathname.includes("employeelist") || location.pathname.includes("employeePerformance") || location.pathname.includes("employeeOverview")) {
      setActiveKey(`2`)
      if (location.pathname.includes("employeeOverview")) {
        if (addManager?.employeeDropShow) {
          dispatch(setEmployeeDropShow(false));
        }
      }
    } else {
      setActiveKey(""); // Setting empty string instead of null
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   if (localStorage.getItem("roleDetails")) {
  //     let roleDetails = JSON.parse(
  //       localStorage.getItem("roleDetails") as string
  //     );
  //     let accessInfo: AccessInfo = {};
  //     Object.entries(
  //       roleDetails?.features as { [key: string]: FeatureDetails }
  //     )?.map(([key, value]) => {
  //       if (key === "manager" && value?.status) {
  //         value?.features?.forEach((res) => {
  //           if (res?.name === "Add Manager" && res.status) {
  //             setAddManagerShow(res.status);
  //           }
  //         });
  //       } else if (key === "setting" && value?.status) {
  //         value?.features?.forEach((res) => {
  //           if (res?.name === "General Setting" && res.status) {
  //             setAccountDetailsShow(res.status);
  //           }
  //         });
  //       } else if (key === "employee" && value?.status) {
  //         value?.features?.forEach((res) => {
  //           if (res?.name === "Employee Directory" && res.status) {
  //             setEmployeeList(res.status);
  //           }
  //           if (res?.name === "Employee Productivity" && res.status) {
  //             setEmployeePerformance(res.status);
  //           }
  //         });
  //       }
  //       accessInfo[key] = value?.status;
  //     });
  //     setAccessInfo(accessInfo);
  //   }
  // }, []);


  useEffect(() => {
    const getRole = async () => {
      try {
        const fulfilledData = await roleDetails();
        if (!fulfilledData || Object.keys(fulfilledData).length === 0) {
          document.cookie =
            "X-XSRF-TOKEN=null; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        let accessInfo: AccessInfo = {};
        Object.entries(
          fulfilledData?.features as { [key: string]: FeatureDetails }
        )?.map(([key, value]) => {
          if (key === "manager" && value?.status) {
            value?.features?.forEach((res) => {
              if (res?.name === "Add Manager" && res.status) {
                setAddManagerShow(res.status);
              }
              if (res?.name === "Manager List" && res.status) {
                setManagerList(res.status);
              }
            });
          } else if (key === "setting" && value?.status) {
            value?.features?.forEach((res) => {
              if (res?.name === "General Setting" && res.status) {
                setAccountDetailsShow(res.status);
              }
            });
          } else if (key === "employee" && value?.status) {
            value?.features?.forEach((res) => {
              if (res?.name === "Employee Directory" && res.status) {
                setEmployeeList(res.status);
              }
              if (res?.name === "Employee Productivity" && res.status) {
                setEmployeePerformance(res.status);
              }
            });
          }
          accessInfo[key] = value?.status;
        });
        setAccessInfo(accessInfo);
      } catch (error) {
        console.error("Decryption failed:", error);
      }
    };

    getRole();
  }, []);

  const getProfileData = () => {
    commonGetService(`/api/1.0/setting/profile/id`).then((res) => {
      if (res.status === 200) {
        // setCurrentProfileDetail({
        //     name: res.data.name,
        //     picture: res.data.profile_picture_path,
        //     role: res.data.role_name,
        //     employee_id: res.data.emp_code,
        // })

        setCurrentUserEmailId(res.data.email);

        setCurrentProfileDetail(() => ({
          name: res.data.name,
          picture: res.data.profile_picture_path,
          role: res.data.role_name,
          employee_id: res.data.emp_code,
        }));
        dispatch(
          setUserRole(res.data.role_name)
        )
      }
    });
  };

  useEffect(() => {
    getProfileData();
  }, [updateProfilePic]);



  const handleNavClose = () => {
    setNavShow(false);
    if (location.pathname.includes("managerList")) {
      setActiveKey("0");
    } else if (location.pathname.includes("roles")) {
      setActiveKey("1");
    } else if (location.pathname.includes("employeelist") || location.pathname.includes("employeePerformance") || location.pathname.includes("employeeOverview")) {
      setActiveKey(`2`)
    } else {
      setActiveKey("");
    }
  };

  const handleTab = (tab: string) => {
    setSelectedTab(tab);
    let today = new Date();
    dispatch(setDeviceID(""));
    dispatch(setDate({ startDate: today, endDate: today }));
    dispatch(setFilterChosen("today"));
    dispatch(setFilterType("organization"));
    dispatch(setDepartment(""));
    dispatch(setEmployeeIds([]));
    dispatch(setOrganization("All Organizations"));
    dispatch(setReportTypes([]));
    dispatch(setAllusers(false));
    dispatch(setDepartmentLists([]));
    dispatch(setDesignationLists([]));
    dispatch(setSystemStatusLists([]));
    dispatch(setEmployeeStatusLists([]));
    dispatch(setRangeValueListsPerformance([0, 100]));
    dispatch(setRangeValueLists1Performance([0, 100]));
    dispatch(setDepartmentListsPerformance([]));
    dispatch(setDesignationListsPerformance([]));
    dispatch(setEmployeeSearch(""));
    dispatch(setSearchPerformance(""));
    if (tab !== "employees" && tab !== "employeePerformance") {
      dispatch(setEmployeeDropShow(false));
    }
    if (tab !== "managerList") {
      dispatch(setManagerDropShow(false));
    }
    if (tab !== "roles") {
      dispatch(setMoreDropShow(false));
    }

    if (tab === "dashboard") {
      Navigate("/dashboard");
    } else if (tab === "screenshots") {
      Navigate("/screenshots");
    } else if (tab === "setting") {
      Navigate("/settings");
      setSelectedTab("settings");
    } else if (tab === "managerList") {
      Navigate("/managerList", { state: { state: currentUserEmailId } });
    } else if (tab === "roles") {
      Navigate("/roles");
    } else if (tab === "reports") {
      Navigate("/reports");
    } else if (tab === "employees") {
      Navigate("/employeelist");
    } else if (tab === "employeePerformance") {
      Navigate("/employeePerformance");
    }
  };

  const handleSelect = (key: any) => {
    setActiveKey(key);
  };

  const handleMouseEnter = (tab: string) => {
    setHoveredState({
      dashboardHover: false,
      settingHover: false,
      projectHover: false,
      managerHover: false,
      addManagerHover: false,
      managerListHover: false,
      reportHover: false,
      screenshotHover: false,
      moreHover: false,
      roleHover: false,
      employeeHover: false,
      [`${tab}Hover`]: true, // Dynamically set the hovered tab
    });
  };

  const handleMouseLeave = () => {
    setHoveredState({
      dashboardHover: false,
      settingHover: false,
      projectHover: false,
      managerHover: false,
      addManagerHover: false,
      managerListHover: false,
      reportHover: false,
      screenshotHover: false,
      moreHover: false,
      roleHover: false,
      employeeHover: false,
    });
  };
  const handleLogout = () => {
    document.cookie =
      "X-XSRF-TOKEN = null;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.clear();
    window.location.href = "/";
    // navigate("/")
  };
  return (
    <Container fluid className="w-100 vh-100 d-flex flex-column m-0 p-0">
      <Row className="nav-bar justify-content-between align-items-center m-0 nav-menu-max position-fixed w-100 top-0">
        <Col
          className="p-0 menu-btn cursor-pointer"
          md="auto"
          onClick={() => setNavShow(true)}
        >
          <Image src="/images/dashboard/menu_button.svg" alt="Menu button" />
        </Col>
        <Col className="p-0 cursor-pointer" lg={2} md>
          <Link
            to="/dashboard"
            onClick={(e) => {
              e.preventDefault();
              !location.pathname.includes("dashboard") &&
                handleTab("dashboard");
            }}
          >
            <Image
              src="/images/dashboard/timelyze_new_logo_tab.svg"
              className="brand-logo"
            />
          </Link>
        </Col>
        <Col
          className="d-flex align-items-center cursor-pointer justify-content-center nav-menu p-0 "
          lg={7}
        >
          {accessInfo?.dashboard && (
            <div
              className={`d-flex align-items-center cursor-pointer ${location.pathname.includes("dashboard") ? "active-tab" : ""
                }`}
              onClick={() => {
                !location.pathname.includes("dashboard") &&
                  handleTab("dashboard");
                dispatch(setManagerDropShow(false));
              }}
            >
              <div>
                <Image
                  src="/images/dashboard/dashboard_icon.svg"
                  alt="Dashboard"
                />
              </div>
              <p>Dashboard</p>
            </div>
          )}
          {accessInfo?.employee && <div
            className={`drop-mngr d-flex align-items-center 
            ${location.pathname.includes("employeelist") ||
                location.pathname.includes("employeePerformance") ||
                location.pathname.includes("employeeOverview")
                ? "active-tab"
                : " "
              }`}
            onClick={() => {
              dispatch(setEmployeeDropShow(!addManager?.employeeDropShow));
            }}
          >
            <div className="me-2">
              <Image
                src={`/images/dashboard/employee_tab.svg`}
                alt="Employee"
                className="cursor-pointer tab-icon"
              />
            </div>
            <DropdownButton
              id="emp-dropdown"
              title="Employee"
              onToggle={() => {
                dispatch(setEmployeeDropShow(!addManager?.employeeDropShow));
              }}
              show={addManager?.employeeDropShow}
            >
              <div>
                {employeeList && <Dropdown.Item
                  onClick={() => {
                    handleTab("employees");
                  }}
                >
                  Emp Directory
                </Dropdown.Item>}
                {employeePerformance && <Dropdown.Item
                  onClick={() => {
                    handleTab("employeePerformance");
                  }}
                >
                  Emp Productivity
                </Dropdown.Item>}
              </div>
            </DropdownButton>
            <div>
              <Image
                src={`/images/dashboard/more_down_arrow.svg`}
                alt="Down Arrow"
                className={`cursor-pointer ms-2 ${addManager?.employeeDropShow
                  ? "rotate_arrow"
                  : "rotate_arrow_back"
                  } `}
              />
            </div>
          </div>}
          {accessInfo?.projects && (
            <div
              className={`d-flex align-items-center cursor-pointer ${location.pathname.includes("projects") ? "active-tab" : ""
                }`}
            >
              {/* <div> */}
              <Image src="/images/dashboard/project_icon.svg" alt="Projects" />
              {/* </div> */}
              <p>Projects</p>
            </div>
          )}
          {/* <div
            className={`d-flex align-items-center cursor-pointer ${location.pathname.includes("manualTime") ? "active-tab" : " "
              }`}
            onClick={() => handleTab("manualTime")}
          >
            <div>
              <Image
                src="/images/dashboard/clock_icon.svg"
                alt="Manural Time"
              />
            </div>
            <p>Manual Time</p>
          </div> */}
          {/* <div
            className={`d-flex align-items-center cursor-pointer ${location.pathname.includes("addManager") ? "active-tab" : " "
              }`}
            onClick={() => handleTab("addManager")}
          >
            <div>
              <Image src="/images/dashboard/add_icon.svg" alt="Add Manager" />
            </div>
            <p>Add Manager</p>
          </div> */}

          {accessInfo?.manager && (
            <div
              className={`drop-mngr d-flex align-items-center ${location.pathname.includes("managerList") ? "active-tab" : " "
                }`}
              onClick={() => {
                dispatch(setManagerDropShow(!addManager?.managerDropShow));
              }}
            >
              <div className="me-2">
                <Image
                  src={`/images/dashboard/manager_tab.svg`}
                  alt="Manager"
                  className="cursor-pointer tab-icon"
                />
              </div>
              <DropdownButton
                id="mngr-dropdown"
                title="Managers"
                onToggle={() => {
                  dispatch(setManagerDropShow(!addManager?.managerDropShow));
                }}
                show={addManager?.managerDropShow}
              >
                <div>
                  {addManagerShow && (
                    <Dropdown.Item onClick={() => dispatch(setModalShow(true))}>
                      Add Manager
                    </Dropdown.Item>
                  )}
                  {managerList && <Dropdown.Item
                    onClick={() => {
                      handleTab("managerList");
                    }}
                  >
                    Manager List
                  </Dropdown.Item>}
                </div>
              </DropdownButton>
              <div>
                <Image
                  src={`/images/dashboard/more_down_arrow.svg`}
                  alt="Down Arrow"
                  className={`cursor-pointer ms-2 ${addManager?.managerDropShow
                    ? "rotate_arrow"
                    : "rotate_arrow_back"
                    } `}
                // style={!addManager?.managerDropShow && !location.pathname.includes("managerList") ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}
                />
              </div>
            </div>
          )}

          {accessInfo?.reports && (
            <div
              className={`d-flex align-items-center cursor-pointer ${location.pathname.includes("reports") ? "active-tab" : " "
                }`}
              onClick={() =>
                !location.pathname.includes("reports") && handleTab("reports")
              }
            >
              <div>
                <Image src="/images/dashboard/report_icon.svg" alt="Reports" />
              </div>
              <p>Reports</p>
            </div>
          )}
          {accessInfo?.screenshot && (
            <div
              className={`d-flex align-items-center cursor-pointer ${location.pathname.includes("screenshots") ? "active-tab" : ""
                }`}
              onClick={() =>
                !location.pathname.includes("screenshots") &&
                handleTab("screenshots")
              }
            >
              <div>
                <Image
                  src={`/images/dashboard/screenshot_logo.svg`}
                  alt="screenshots"
                />
              </div>
              <p>Screenshots</p>
            </div>
          )}
          {accessInfo?.roles && (
            <div
              className={`drop-more role-cls d-flex align-items-center cursor-pointer ${location.pathname.includes("roles") ? "active-tab" : " "
                }`}
              onClick={() => {
                dispatch(setMoreDropShow(!addManager?.moreDropShow));
              }}
            >
              <DropdownButton
                id="role-dropdown"
                title="More"
                onToggle={() =>
                  dispatch(setMoreDropShow(!addManager?.moreDropShow))
                }
                show={addManager?.moreDropShow}
              >
                <Dropdown.Item onClick={() => handleTab("roles")}>
                  Roles
                </Dropdown.Item>
              </DropdownButton>
              <div>
                <Image
                  src={`/images/dashboard/more_down_arrow.svg`}
                  alt="Down Arrow"
                  className={`cursor-pointer ms-2 ${addManager?.moreDropShow
                    ? "rotate_arrow"
                    : "rotate_arrow_back"
                    } `}
                />
              </div>
            </div>
          )}
        </Col>
        <Col
          className="p-0 d-flex align-items-center cursor-pointer nav-search"
          md
          lg={3}
        >
          {/* Hiding this below code due to no functionality */}

          {/* <div className="ms-auto">
            <Image
              src="/images/dashboard/search_icon.svg"
              alt="Search"
              className="search-icon"
            />
          </div> */}

          {/* <div className="note-box">
            <Image
              src="/images/dashboard/notification_icon.svg"
              alt="Notification"
              className="not-icon"
            />
            <span className="d-inline-block">12</span>
          </div> */}
          {/* <NotificationDropdown /> */}
          <div className="split-pipe"></div>

          {accessInfo?.setting && (
            <div className="setting" onClick={() => handleTab("setting")}>
              <Image src="/images/dashboard/setting_icon.svg" alt="Setting" />
            </div>
          )}

          <ProfileBadge
            userDetails={currentProfileDetail}
            isSetting={accountDetailsShow}
          />
        </Col>
      </Row>
      <Offcanvas
        placement="start"
        show={navShow}
        onHide={() => handleNavClose()}
        className="side-menu"
      >
        <Offcanvas.Header className="justify-content-between">
          <Offcanvas.Title>
            <Image
              src="/images/dashboard/timelyze_new_logo_tab.svg"
              className="brand-logo"
            />
          </Offcanvas.Title>
          <Image
            src="/images/dashboard/side_menu_close.svg"
            className="side-close cursor-pointer"
            onClick={() => handleNavClose()}
          />
        </Offcanvas.Header>
        <Offcanvas.Body className="side-menu-body p-0 d-flex flex-column">
          <div className="d-flex flex-column">
            {accessInfo?.dashboard && (
              <div
                className={`d-flex flex-row menu-title-cont ${dashboardHover ||
                  (location.pathname.includes("dashboard") && !activeKey)
                  ? "active-tab"
                  : ""
                  }`}
                onClick={() => handleTab("dashboard")}
                onMouseEnter={() => handleMouseEnter("dashboard")}
                onMouseLeave={() => handleMouseLeave()}
              >
                <div>
                  {/* <Image
                    src={

                      dashboardHover ||
                        (location.pathname.includes("dashboard") && !activeKey)
                        ? "/images/dashboard/dashboard_icon.svg"
                        : "/images/dashboard/fade_dashboard_icon.svg"
                    }
                    alt="Dashboard"
                    style={!dashboardHover && !(location.pathname.includes("dashboard") && !activeKey) ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}

                  /> */}

                  <Image
                    src="/images/dashboard/dashboard_icon.svg"
                    alt="Dashboard"
                    style={
                      !dashboardHover &&
                        !(location.pathname.includes("dashboard") && !activeKey)
                        ? {
                          filter:
                            "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                        }
                        : {}
                    }
                  />
                </div>
                <p>Dashboard</p>
              </div>
            )}
            {accessInfo?.projects && (
              <div
                className={`d-flex flex-row menu-title-cont `}
                onMouseEnter={() => handleMouseEnter("project")}
                onMouseLeave={() => handleMouseLeave()}
              >
                <div>
                  {/* <Image
                    src={
                      projectHover
                        ? "/images/dashboard/project_icon.svg"
                        : "/images/dashboard/fade_project_icon.svg"
                    }
                    alt="project"
                     style={!projectHover ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}
                  /> */}

                  <Image
                    src="/images/dashboard/project_icon.svg"
                    alt="project"
                    style={
                      !projectHover
                        ? {
                          filter:
                            "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                        }
                        : {}
                    }
                  />
                </div>
                <p>Projects</p>
              </div>
            )}
            {accessInfo?.employee && (
              <div
                className={`drop-side-mngr d-flex flex-row align-items-start menu-title-cont ${location.pathname.includes("employeelist") ||
                  location.pathname.includes("employeePerformance") ||
                  location.pathname.includes("employeeOverview") ||
                  employeeHover ||
                  activeKey === "2"
                  ? "active-tab"
                  : ""
                  }`}
                onMouseEnter={() => handleMouseEnter("employee")}
                onMouseLeave={() => handleMouseLeave()}
              >
                <Image
                  src="/images/dashboard/employee_tab.svg"
                  alt="Employee"
                  className=""
                  style={
                    !employeeHover &&
                      !(
                        location.pathname.includes("employeelist") ||
                        location.pathname.includes("employeePerformance") ||
                        location.pathname.includes("employeeOverview") ||
                        activeKey === "2"
                      )
                      ? {
                        filter:
                          "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                      }
                      : {}
                  }
                />
                <Accordion
                  className={`drop-mngr  `}
                  activeKey={activeKey}
                  onSelect={handleSelect}
                >
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <p> Employee</p>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                      // onClick={() =>

                      // }
                      >
                        {employeeList && <Accordion.Item
                          className={` ${location.pathname.includes("employeelist")
                            ? "active-tab" : ""}`}
                          onMouseEnter={() => handleMouseEnter("employee")}
                          onMouseLeave={() => handleMouseLeave()}
                          eventKey="1"
                          onClick={() => {
                            handleTab("employees")
                          }}
                        >

                          <Image
                            src="/images/roles/white_add_manager.svg"
                            alt="Employee Directory"
                            style={
                              !(location.pathname.includes("employeelist") && activeKey === "2") ? {
                                filter:
                                  "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                              }
                                : {}
                            }
                          />
                          <p> Emp Directory</p>
                        </Accordion.Item>}
                        {employeePerformance && <Accordion.Item
                          className={` ${location.pathname.includes("employeePerformance")
                            ? "active-tab"
                            : ""
                            }`}
                          eventKey="2"
                          onMouseEnter={() => handleMouseEnter("employeePerformance")}
                          onMouseLeave={() => handleMouseLeave()}
                          onClick={() => handleTab("employeePerformance")}
                        >

                          <Image
                            src="/images/roles/white_managerList.svg"
                            alt="ManagerList"
                            style={
                              !location.pathname.includes("employeePerformance") && activeKey === "2"
                                ? {
                                  filter:
                                    "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                                }
                                : {}
                            }
                          />

                          <p>  Emp Productivity</p>
                        </Accordion.Item>}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )}
            {accessInfo?.manager && (
              <div
                className={`drop-side-mngr d-flex flex-row align-items-start menu-title-cont ${location.pathname.includes("managerList") ||
                  managerHover ||
                  activeKey === "0"
                  ? "active-tab"
                  : ""
                  }`}
                onClick={() => setIsManagerDropdown(!isManagerDropdown)}
                onMouseEnter={() => handleMouseEnter("manager")}
                onMouseLeave={() => handleMouseLeave()}
              >
                {/* <Image
                  src={
                    managerHover ||
                      location.pathname.includes("managerList") ||
                      activeKey === "0"
                      ? "/images/dashboard/manager.svg"
                      : "/images/dashboard/fade_manager.svg"
                  }
                  alt="manager"
                  className=""
                  style={!managerHover && !(location.pathname.includes("managerList") || activeKey === "0") ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}
                /> */}

                <Image
                  src="/images/dashboard/manager.svg"
                  alt="manager"
                  className=""
                  style={
                    !managerHover &&
                      !(
                        location.pathname.includes("managerList") ||
                        activeKey === "0"
                      )
                      ? {
                        filter:
                          "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                      }
                      : {}
                  }
                />
                <Accordion
                  className={`drop-mngr  `}
                  activeKey={activeKey}
                  onSelect={handleSelect}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <p> Managers</p>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        onClick={() =>
                          dispatch(
                            setManagerDropShow(!addManager?.managerDropShow)
                          )
                        }
                      >
                        {addManagerShow && <Accordion.Item
                          className={`${addManagerHover ? "active-tab" : ""}`}
                          onMouseEnter={() => handleMouseEnter("addManager")}
                          onMouseLeave={() => handleMouseLeave()}
                          eventKey="1"
                          onClick={() => {
                            handleNavClose();
                            location.pathname.includes("managerList")
                              ? setActiveKey("0")
                              : location.pathname.includes("roles")
                                ? setActiveKey("1")
                                : setActiveKey("");
                            dispatch(setModalShow(true));
                          }}
                        >
                          {/* <Image
                            src={` /images/roles/${addManagerHover
                              ? "white_add_manager.svg"
                              : "inactive_add_manager.svg"
                              }`}
                            alt="Add Manager"
                            style={!addManagerHover ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}

                          /> */}
                          <Image
                            src="/images/roles/white_add_manager.svg"
                            alt="Add Manager"
                            style={
                              !addManagerHover
                                ? {
                                  filter:
                                    "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                                }
                                : {}
                            }
                          />
                          <p> Add Manager</p>
                        </Accordion.Item>}
                        {managerList && <Accordion.Item
                          className={`${location.pathname.includes("managerList") ||
                            managerListHover
                            ? "active-tab"
                            : ""
                            }`}
                          eventKey="2"
                          onMouseEnter={() => handleMouseEnter("managerList")}
                          onMouseLeave={() => handleMouseLeave()}
                          onClick={() => handleTab("managerList")}
                        >
                          {/* <Image
                            src={`/images/roles/${managerListHover ||
                              location.pathname.includes("managerList")
                              ? "white_managerList.svg"
                              : "inactive_manager_list.svg"
                              }`}
                            alt="ManagerList"
                            style={!managerListHover && !location.pathname.includes("managerList") ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}

                          /> */}
                          <Image
                            src="/images/roles/white_managerList.svg"
                            alt="ManagerList"
                            style={
                              !managerListHover &&
                                !location.pathname.includes("managerList")
                                ? {
                                  filter:
                                    "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                                }
                                : {}
                            }
                          />

                          <p> Manager List</p>
                        </Accordion.Item>
                        }</div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )}
            {accessInfo?.reports && (
              <div
                className={`d-flex flex-row menu-title-cont ${location.pathname.includes("reports") && !activeKey
                  ? "active-tab"
                  : ""
                  }`}
                onMouseEnter={() => handleMouseEnter("reports")}
                onMouseLeave={() => handleMouseLeave()}
                onClick={() => handleTab("reports")}
              >
                <div>
                  {/* <Image
                    src={
                      (reportHover ||
                        selectedTab === "reports" ||
                        (location.pathname.includes("reports") && (!activeKey)))

                        ? "/images/dashboard/report_icon.svg"
                        : "/images/dashboard/fade_report_icon.svg"
                    }
                    alt="Reports"
                    style={!reportHover && !(location.pathname.includes("reports") && !activeKey) ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}

                  /> */}
                  <Image
                    src="/images/dashboard/report_icon.svg"
                    alt="Reports"
                    style={
                      !reportHover &&
                        !(location.pathname.includes("reports") && !activeKey)
                        ? {
                          filter:
                            "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                        }
                        : {}
                    }
                  />
                </div>
                <p>Reports</p>
              </div>
            )}
            {accessInfo?.screenshot && (
              <div
                className={`d-flex flex-row menu-title-cont ${(location.pathname.includes("screenshots") && !activeKey) ||
                  screenshotHover
                  ? "active-tab"
                  : ""
                  }`}
                onMouseEnter={() => handleMouseEnter("screenshots")}
                onMouseLeave={() => handleMouseLeave()}
                onClick={() => handleTab("screenshots")}
              >
                <div>
                  {/* <Image
                    src={
                      (screenshotHover || (location.pathname.includes("screenshots") && !activeKey)
                      ) ? "/images/dashboard/screenshot_logo.svg"
                        : "/images/dashboard/fade_screenshot_icon.svg"
                    }
                    alt="Add Manager"

                    style={!screenshotHover && !(location.pathname.includes("screenshots") && !activeKey) ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}
                  /> */}
                  <Image
                    src="/images/dashboard/screenshot_logo.svg"
                    alt="Add Manager"
                    style={!screenshotHover && !(location.pathname.includes("screenshots") && !activeKey)
                      ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' }
                      : {}
                    }
                  />
                </div>
                <p>Screenshots</p>
              </div>
            )}

            {accessInfo?.roles && (
              <div
                className={`drop-side-mngr d-flex flex-row align-items-start menu-title-cont ${moreHover ||
                  location.pathname.includes("roles") ||
                  activeKey === "1"
                  ? "active-tab"
                  : ""
                  }`}
                onMouseEnter={() => handleMouseEnter("more")}
                onMouseLeave={() => handleMouseLeave()}
                onClick={() => setIsMoreClicked(!isMoreClicked)}
              >
                {/* <Image
                  src={
                    (moreHover ||
                      location.pathname.includes("roles")) ||
                      activeKey === "1"
                      ? "/images/dashboard/three_dot.svg"
                      : "/images/dashboard/fade_three_dot.svg"
                  }
                  alt="manager"
                  className=""
                  style={!moreHover && !(location.pathname.includes("roles") || activeKey === "1") ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}
                /> */}
                <Image
                  src="/images/dashboard/three_dot.svg"
                  alt="manager"
                  className=""
                  style={
                    !moreHover &&
                      !(location.pathname.includes("roles") || activeKey === "1")
                      ? {
                        filter:
                          "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                      }
                      : {}
                  }
                />
                <Accordion
                  className={`drop-mngr `}
                  activeKey={activeKey}
                  onSelect={handleSelect}
                >
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <p>More</p>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div>
                        <Accordion.Item
                          onMouseEnter={() => handleMouseEnter("role")}
                          onMouseLeave={() => handleMouseLeave()}
                          className={`${location.pathname.includes("roles") || roleHover
                            ? "active-tab"
                            : ""
                            }`}
                          eventKey="1"
                          onClick={() => handleTab("roles")}
                        >
                          <p> Roles</p>
                        </Accordion.Item>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )}
          </div>

          <div className="d-flex flex-column mt-auto">
            {accessInfo?.setting && (
              <div
                className={`d-flex flex-row menu-title-cont ${location.pathname.includes("settings") ? "active-tab" : ""
                  }`}
                onMouseEnter={() => handleMouseEnter("setting")}
                onMouseLeave={() => handleMouseLeave()}
                onClick={() => handleTab("setting")}
              >
                <div>
                  {/* <Image
                    src={
                      settingHover ||
                        selectedTab === "settings" ||
                        location.pathname.includes("settings")
                        ? "/images/dashboard/setting_icon.svg"
                        : "/images/dashboard/fade_setting_icon.svg"
                    }
                    alt="Setting"
                    style={!settingHover && !location.pathname.includes("settings") ? { filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' } : {}}
                  /> */}
                  <Image
                    src="/images/dashboard/setting_icon.svg"
                    alt="Setting"
                    style={
                      !settingHover && !location.pathname.includes("settings")
                        ? {
                          filter:
                            "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                        }
                        : {}
                    }
                  />
                </div>
                <p>Settings</p>
              </div>
            )}
            <div
              className={`d-flex flex-row menu-title-cont ${selectedTab === "logout" ? "active-tab" : ""
                }`}
              onClick={() => handleLogout()}
            >
              <div>
                {/* <Image
                  src="/images/dashboard/fade_logout_icon.svg"
                  alt="Add Manager"
                  style={{ filter: 'brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)' }}

                /> */}
                <Image
                  src="/images/dashboard/fade_logout_icon.svg"
                  alt="Add Manager"
                  style={{
                    filter:
                      "brightness(0) saturate(100%) invert(59%) sepia(7%) saturate(857%) hue-rotate(93deg) brightness(88%) contrast(86%)",
                  }}
                />
              </div>
              <p>Logout</p>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <>{props.children}</>
    </Container>
  );
};

export default NavbarLayout;
